export default "__VITE_ASSET__B11s2o$2__"